<template>
  <div>
    <div class="headBox">
      <div class="box">
        <div class="title">玉环人力网</div>
        <div class="text">一站式人才服务</div>
      </div>
      <div class="img">
        <img src="../../assets/img/yizhan.png" alt="" />
      </div>
    </div>
    <div class="content">
      <div class="titleBox dis-cent">在校生实践</div>
      <div class="contBox">
        <div
          class="cont"
          @click="urlClick('https://www.yhrl.com/#/newsIndex')"
        >
          <div class="img yanse2 dis-cent">
            <div class="iconfont icon-qiuzhizhe"></div>
          </div>
          <div class="text">大学生实习</div>
        </div>
        <div
          class="cont"
          @click="urlClick('https://www.yhrl.com/#/newsIndex')"
        >
          <div class="img dis-cent">
            <div class="iconfont icon-xuanchuanziliao"></div>
          </div>
          <div class="text">人才政策</div>
        </div>
      </div>
      <div class="titleBox dis-cent">毕业生找工作</div>
      <div class="contBox">
        <div
          class="cont"
          @click="urlClick('https://www.yhrl.com/#/jobIndex')"
        >
          <div class="img yanse5 dis-cent">
            <div class="iconfont icon-qiuzhizhe"></div>
          </div>
          <div class="text">找工作</div>
        </div>
        <div
          class="cont"
          @click="urlClick('https://www.yhrl.com/#/comIndex')"
        >
          <div class="img yanse4 dis-cent">
            <div class="iconfont icon-zhaopin wz2"></div>
          </div>
          <div class="text">网络招聘</div>
        </div>
        <div
          class="cont"
          @click="urlClick('https://www.yhrl.com/#/zhpIndex')"
        >
          <div class="img yanse9 dis-cent">
            <div class="iconfont icon-zhaopinhui wz1"></div>
          </div>
          <div class="text">现场招聘</div>
        </div>
      </div>
      <div class="titleBox dis-cent">就业手续办理</div>
      <div class="contBox">
        <div
          class="cont"
          @click="
            urlClick(
              'https://puser.zjzwfw.gov.cn/sso/usp.do?action=ssoLogin&servicecode=zwtyyw&goto=https%3A%2F%2Frecept.zjzwfw.gov.cn%2Fonline%2Faccept%23%2Faccept%2Fentry%3FmatterType%3DpowerDirectory%26matterId%3D101300127'
            )
          "
        >
          <div class="img yanse4 dis-cent">
            <div class="iconfont icon--dangan"></div>
          </div>
          <div class="text">档案查询</div>
        </div>
        <div
          class="cont"
          @click="
            urlClick(
              'https://www.zjzwfw.gov.cn/zjservice/item/detail/index.do?localInnerCode=34c8f846-3ac0-459f-a5c8-967eed95994d&jurisCode=330301'
            )
          "
        >
          <div class="img yanse10 dis-cent">
            <div class="iconfont icon-rollout wz3"></div>
          </div>
          <div class="text">档案接收</div>
        </div>
        <div
          class="cont"
          @click="
            urlClick(
              'https://www.zjzwfw.gov.cn/zjservice/item/detail/index.do?localInnerCode=c03dd887-9175-4038-82ae-70c700f3d0c2&jurisCode=330301'
            )
          "
        >
          <div class="img yanse11 dis-cent">
            <div class="iconfont icon-danganzhuanchu wz3"></div>
          </div>
          <div class="text">档案转出</div>
        </div>
        <div
          class="cont"
          @click="urlClick('https://zcps.rlsbt.zj.gov.cn/028/client/index.jsp')"
        >
          <div class="img yanse5 dis-cent">
            <div class="iconfont icon-zhicheng1"></div>
          </div>
          <div class="text">职称初定</div>
        </div>
        <div
          class="cont"
          @click="
            urlClick(
              'https://www.zjzwfw.gov.cn/zjservice/item/detail/index.do?localInnerCode=6301e04f-07b6-4027-99dc-64864492ac57&jurisCode=330301'
            )
          "
        >
          <div class="img dis-cent">
            <div class="iconfont icon-kaizhengming"></div>
          </div>
          <div class="text">出具证明</div>
        </div>
        <div
          class="cont"
          @click="
            urlClick(
              'https://www.zjzwfw.gov.cn/zjservice/item/detail/index.do?localInnerCode=61e7231c-732c-42bc-b8ce-01d0b948fa3f&jurisCode=330301'
            )
          "
        >
          <div class="img yanse7 dis-cent">
            <div class="iconfont icon-he_11hangzhengshenpizhuanyongzhang"></div>
          </div>
          <div class="text">政审（考察）</div>
        </div>
        <div
          class="cont"
          @click="
            urlClick(
              'https://www.zjzwfw.gov.cn/zjservice/item/detail/index.do?localInnerCode=16183213-d469-4e2d-bfb4-b8f6bf560136&jurisCode=330301'
            )
          "
        >
          <div class="img yanse4 dis-cent">
            <div class="iconfont icon-ziliao"></div>
          </div>
          <div class="text">档案材料收集</div>
        </div>
        <div
          class="cont"
          @click="
            urlClick(
              'https://puser.zjzwfw.gov.cn/sso/usp.do?action=ssoLogin&servicecode=zwtyyw&goto=https%3A%2F%2Frecept.zjzwfw.gov.cn%2Fonline%2Faccept%23%2Faccept%2Fentry%3FmatterType%3DpowerDirectory%26matterId%3D101300127'
            )
          "
        >
          <div class="img yanse8 dis-cent">
            <div class="iconfont icon-chaxun1"></div>
          </div>
          <div class="text">档案查阅</div>
        </div>
      </div>
      <div class="titleBox dis-cent">人才服务</div>
      <div class="contBox">
        <div
          class="cont"
          @click="urlClick('https://rc-zzb.wenzhou.gov.cn:65443/rcApp/#/')"
        >
          <div class="img dis-cent">
            <div class="iconfont icon-rencaifuwu"></div>
          </div>
          <div class="text">人才院</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {};
  },
  created() {},
  methods: {
    urlClick(url) {
      window.open(url);
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.headBox {
  background-color: #ecf4ff;
  border-radius: 10px;
  width: 1280px;
  margin: auto;
  margin-top: 15px;
  height: 350px;
  display: flex;
  align-items: center;
  padding: 0 120px;
  box-sizing: border-box;
  .box {
    flex: 1;
    padding-left: 40px;
    display: flex;
    flex-direction: column;
    .title {
      font-weight: 600;
      font-size: 44px;
      color: #1a78ec;
    }
    .text {
      margin-top: 40px;
      font-size: 16px;
    }
  }
  .img {
    height: 310px;
    img {
      width: auto;
    }
  }
}
.content {
  width: 1280px;
  margin: auto;
  .titleBox {
    font-size: 26px;
    font-weight: 600;
    margin-top: 40px;
  }
  .contBox {
    background-color: #fff;
    border-radius: 10px;
    margin-top: 25px;
    padding: 40px 60px;
    padding-bottom: 0;
    display: flex;
    flex-wrap: wrap;
    .cont {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      // margin-right: 40px;
      width: 25%;
      margin-bottom: 40px;
      .img {
        width: 90px;
        border-radius: 50%;
        color: #fff;
        height: 90px;
        background: linear-gradient(45deg, #45b1ff, #2a89ce);
        .iconfont {
          font-size: 40px;
        }
      }
      .wz1 {
        position: relative;
        left: 4px;
      }
      .wz2 {
        position: relative;
        left: 1px;
      }
      .wz3 {
        position: relative;
        top: -2px;
      }
      .yanse1 {
        background: linear-gradient(to right, #45b1ff, #2a89ce);
      }
      .yanse2 {
        background: linear-gradient(to right, #ffb249, #e2952a);
      }
      .yanse3 {
        background: linear-gradient(to right, #45a5ff, #3499eb);
      }
      .yanse4 {
        background: linear-gradient(to right, #f59352, #e06e39);
      }
      .yanse5 {
        background: linear-gradient(to right, #45c4ff, #45c4ff);
      }
      .yanse6 {
        background: linear-gradient(to right, #ff4583, #ff45b2);
      }
      .yanse7 {
        background: linear-gradient(to right, #5bc43c, #27ca21);
      }
      .yanse8 {
        background: linear-gradient(to right, #ffc445, #ffbe45);
      }
      .yanse9 {
        background: linear-gradient(to right, #ff5145, #ff4545);
      }
      .yanse10 {
        background: linear-gradient(to right, #3859eb, #354fe6);
      }
      .yanse11 {
        background: linear-gradient(to right, #8c38eb, #9d2bdf);
      }
      .text {
        margin-top: 10px;
      }
    }
    .cont:hover {
      .iconfont {
        animation: 1s both xuanzhuan;
      }
      @keyframes xuanzhuan {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    }
  }
}
</style>
